class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.slideSpeed = parseInt(this.dataset.slideSpeed ?? 100);
    this.items = [...this.children];
    this.animate = horizontalLoop(this.items, {paused: true});
    this.setupDragEvents();
    if(!Shopify.designMode) {
      this.observeInViewport();
    }

    // Stop the scrolling if the user changes tab. This prevents the script from playing catchup if they return to the tab.
    document.addEventListener("visibilitychange", this.stopAutoScroll.bind(this));

    if(this.dataset.sticky === 'true' && !Shopify.designMode) {
      window.addEventListener('load', this.setupSticky.bind(this));
    }
  }

  setupSticky() {
    this.isSticky = false;
    this.homeContainer = this.parentElement;

    ScrollTrigger.create({
      trigger: this.homeContainer,
      start: 'top top-=300',
      onEnter: this.stickToTop.bind(this),
      onLeaveBack: this.unstickFromTop.bind(this)
    });
  }

  stickToTop() {
    if(this.isSticky) {
      return;
    }
    this.isSticky = true;
    this.homeContainer.style.minHeight = `${this.offsetHeight}px`;
    gsap.set(this, {position: 'fixed', top: 0, left: 0, zIndex: 4, yPercent: -100});
    document.body.prepend(this);
    gsap.to(this, {yPercent: 0, duration: 0.4});
  }

  unstickFromTop() {
    if(!this.isSticky) {
      return;
    }
    this.isSticky = false;
    gsap.to(this, {
      yPercent: -100,
      duration: 0.4,
      onComplete: () => {
        gsap.set(this, {clearProps: 'position,top,left,zIndex,yPercent'});
        this.homeContainer.style.minHeight = '';
        this.homeContainer.prepend(this);
      }
    });
  }

  observeInViewport() {
    this.observer && this.observer.disconnect();
    this.observer = new IntersectionObserver(function(entries) {
      if(entries[0].isIntersecting === true) {
        entries[0]['target'].startAutoScroll();
      }
    }, { threshold: [0]});
    if(!Shopify.designMode) {
      this.observer.observe(this);
    }
  }

  observeLeavesViewport() {
    this.observer && this.observer.disconnect();
    this.observer = new IntersectionObserver(function(entries) {
      if(entries[0].isIntersecting !== true) {
        entries[0]['target'].stopAutoScroll();
      }
    }, { threshold: [0]});
    this.observer.observe(this);
  }

  startAutoScroll() {
    this.observeLeavesViewport();
    this.setAutoInterval();
  }

  stopAutoScroll() {
    this.interval && clearInterval(this.interval);
    this.observeInViewport();
  }

  resetAutoInterval() {
    this.interval && clearInterval(this.interval);
    this.setAutoInterval();
  }

  setAutoInterval() {
    if(!Shopify.designMode) {
      this.interval = setInterval(() => {
        this.nextItem();
      }, this.slideSpeed * 1000)
    }
  }

  nextItem() {
    this.resetAutoInterval();
    this.animate.next({duration: 1.5, ease: "power1.inOut"});
  }

  prevItem() {
    this.resetAutoInterval();
    this.animate.previous({duration: 1.5, ease: "power1.inOut"});
  }

  jumpTo(index) {
    this.resetAutoInterval();
    this.animate.toIndex(index, {duration: 1.5, ease: "power1.inOut"})
  }

  setupDragEvents() {
    this.addEventListener('touchstart', this.setTouchPageX.bind(this), { passive: false })
    this.addEventListener('touchend', this.checkTouchDragged.bind(this), { passive: false })
  }

  setTouchPageX(e) {
    const evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    this.screenX = touch.screenX;
  }

  checkTouchDragged(e) {
    const evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    if(touch.screenX < this.screenX) {
      if((this.screenX - touch.screenX) > 40) {
        this.nextItem();
      }
    }
    else if(touch.screenX > this.screenX) {
      if((touch.screenX - this.screenX) > 40) {
        this.prevItem();
      }
    }
  }
  
}

customElements.define('announcement-bar', AnnouncementBar);